import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { BellRing, Loader2, Smartphone } from "lucide-react";

const minAgo = (isoStr) => {
  if (!isoStr) return null;
  const m = Math.round((Date.now() - new Date(isoStr).getTime()) / 60000);
  return m < 1 ? "agora" : `há ${m} min`;
};

// Iter 115: ação do gestor quando o entregador está "sem sinal" — envia o push "acorda GPS" e mostra
// o que o watchdog automático já fez (avisos enviados ao celular).
export function AcordarGpsButton({ entregador, status }) {
  const [busy, setBusy] = useState(false);
  const inc = entregador.gps_incidente;
  const semSinal = status === "no_signal" || status === "offline";
  if (!semSinal) return null;

  const acordar = async (ev) => {
    ev.stopPropagation();
    setBusy(true);
    try {
      const r = await api.post(`/tracking/acordar/${entregador.entregador_id}`);
      if (r.data.ok) toast.success(`Aviso enviado ao celular de ${entregador.nome} (${r.data.devices} aparelho${r.data.devices > 1 ? "s" : ""})`);
      else toast.warning(r.data.detail || "Nenhum celular registrado");
    } catch (e) { toast.error(e?.response?.data?.detail || "Falha ao enviar aviso"); }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-2 flex flex-wrap items-center gap-2" data-testid={`mon-acordar-wrap-${entregador.entregador_id}`}>
      <Button size="sm" variant="outline" onClick={acordar} disabled={busy || entregador.tem_app_nativo === false}
        className="h-7 border-rose-300 text-rose-800 hover:bg-rose-50 text-xs" data-testid={`mon-acordar-${entregador.entregador_id}`}
        title={entregador.tem_app_nativo === false ? "Entregador sem app nativo registrado" : "Envia um push para o celular religar o GPS"}>
        {busy ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" /> : <BellRing className="w-3.5 h-3.5 mr-1" />}Acordar GPS
      </Button>
      {inc?.avisos > 0 && (
        <span className="text-[11px] text-rose-700" data-testid={`mon-acordar-info-${entregador.entregador_id}`}>
          {inc.avisos} aviso{inc.avisos > 1 ? "s" : ""} automático{inc.avisos > 1 ? "s" : ""} · último {minAgo(inc.ultimo_aviso_at)}
        </span>
      )}
      {entregador.tem_app_nativo === false && (
        <span className="text-[11px] text-slate-500 inline-flex items-center gap-1" data-testid={`mon-sem-app-${entregador.entregador_id}`}>
          <Smartphone className="w-3 h-3" /> sem app nativo — só PWA
        </span>
      )}
    </div>
  );
}
